import React, { useEffect, useState } from "react"
import { Card, Col, Row } from "reactstrap"
import toast from "react-hot-toast"

import { Button } from "components/Button"
import { DataTable } from "components/DataTable"
import AddUpdateStageModal from "./Modals/ProductionLineStagesModal/AddUpdateStageModal"
import EditStageModal from "./Modals/ProductionLineStagesModal/EditStagesModal"
import StagesSkeleton from "./ProductionLineSkeleton/StagesSkeleton"
import { GetProductionLineDetails } from "api/api.service"
import { sortStagesDataBySequenceNo } from "pages/Timeline/ProductionSchedule/ProductionSchedule.utils"

const COLUMNS = {
   SR_NO: "Sr. No.",
   STAGES: "Stages",
   STATIONS: "Stations",
   TIME: "Time (Hrs)",
}

const MODAL_TYPE = {
   ADD: "ADD",
   EDIT: "EDIT",
}

export const normalizeStageData = (data, isChangeSequence = false) => {
   return data?.map((item, idx) => {
      return {
         name: item?.name,
         sequence_number: isChangeSequence ? idx + 1 : item?.sequenceNo,
         hours: Number(item?.hours),
         departmentIds: item?.stations.map(dept => dept.departmentId),
      }
   })
}

const formatStationsData = data => {
   return (
      data?.stations
         ?.map(station => station?.department?.departmentName)
         ?.join(", ") || "-"
   )
}

const ProductionLineDetailsStages = ({ productionLineId, hasOrders }) => {
   const [modal, setModal] = useState({
      isOpen: false,
      type: MODAL_TYPE.ADD,
   })
   const [localData, setLocalData] = useState([])
   const [loading, setLoading] = useState(false)
   const STAGE_COUNT = !localData?.length

   useEffect(() => {
      handleFetchStagesDetails()
   }, [])
   const handleFetchStagesDetails = async () => {
      try {
         setLoading(true)
         const res = await GetProductionLineDetails(productionLineId)
         const sortedStages = sortStagesDataBySequenceNo(res?.stages)
         setLocalData(sortedStages)
         return res
      } catch (error) {
         history.push(APP_ROUTES.PRODUCTION_LINE_MANAGEMENT)
         toast.error("Production Line does not exist!")
      } finally {
         setLoading(false)
      }
   }
   const handleModalClose = () => {
      setModal({
         isOpen: false,
         type: MODAL_TYPE.ADD,
      })
   }

   const handleAdd = async bodyData => {
      try {
         setLoading(true)
         const res = await handleFetchStagesDetails()
         setLocalData(res?.stages)
         toast.success("Stage has been added Successfully!")
      } catch (error) {
         toast.error(error.message || "Failed to add Stages")
      } finally {
         setLoading(false)
      }
   }
   const handleUpdate = async () => {
      try {
         setLoading(true)
         const res = await handleFetchStagesDetails()
         setLocalData(res?.stages)
         // toast.success("Stages has been added")
      } catch (error) {
         toast.error(error.message || "Failed to add Stages")
      } finally {
         setLoading(false)
      }
   }

   return (
      <>
         {loading ? (
            <StagesSkeleton />
         ) : (
            <>
               <div className="trailer-container p-4">
                  <div className="d-flex align-items-center justify-content-end gap-2">
                     {!hasOrders && (
                        <Button
                           className={"gt-btn-grad-primary "}
                           title="Add Stage"
                           onClick={() => {
                              setModal({
                                 isOpen: true,
                                 type: MODAL_TYPE.ADD,
                              })
                           }}
                        />
                     )}
                     {localData?.length && !hasOrders ? (
                        <Button
                           className={"gt-btn-grad-primary"}
                           title="Edit Stages"
                           onClick={() => {
                              setModal({
                                 isOpen: true,
                                 type: MODAL_TYPE.EDIT,
                              })
                           }}
                        />
                     ) : (
                        <></>
                     )}
                  </div>
               </div>
               <Card>
                  <Row>
                     <Col md={12}>
                        <DataTable
                           data={localData}
                           tableClasses="trailer-management-table"
                           className="table-responsive scroll-container"
                           // loading={isLoading}
                           config={[
                              {
                                 title: COLUMNS.SR_NO,
                                 className: "",
                                 render: (_, idx) => idx + 1 || "-",
                              },
                              {
                                 title: COLUMNS.STAGES,
                                 className: "",
                                 render: data => data?.name || "-",
                              },
                              {
                                 title: COLUMNS.STATIONS,
                                 className: "",
                                 render: data => formatStationsData(data),
                              },
                              {
                                 title: COLUMNS.TIME,
                                 className: "",
                                 render: data => data?.hours || "-",
                              },
                           ]}
                        />
                     </Col>
                  </Row>
               </Card>
            </>
         )}

         {modal.isOpen && modal.type === MODAL_TYPE.ADD && (
            <AddUpdateStageModal
               isOpen={modal.isOpen && modal.type === MODAL_TYPE.ADD}
               handleModalToggling={handleModalClose}
               stagesData={normalizeStageData(localData)}
               onSuccess={handleAdd}
               productionLineId={productionLineId}
            />
         )}

         {modal.isOpen && modal.type === MODAL_TYPE.EDIT && (
            <EditStageModal
               isOpen={modal.isOpen && modal.type === MODAL_TYPE.EDIT}
               handleModalToggling={handleModalClose}
               stagesData={localData}
               onSuccess={handleUpdate}
               productionLineId={productionLineId}
            />
         )}
      </>
   )
}

export default ProductionLineDetailsStages
